export class CreateUserEntity {
  phone;
  email;
  userTypeId;
  userSiteId;
  platforms;
  carUserTokens;
  utronUser;
  welcomeEmailMessageToSend;
  isFromGmtUser;
  userScopes;
  password;

  constructor(
    phone,
    email,
    userTypeId,
    userSiteId,
    platforms,
    carUserTokens,
    utronUser,
    welcomeEmailMessageToSend,
    isFromGmtUser,
    userScopes,
    password
  ) {
    this.phone = phone;
    this.email = email;
    this.userTypeId = userTypeId;
    this.userSiteId = userSiteId;
    this.platforms = platforms;
    this.carUserTokens = carUserTokens;
    this.utronUser = utronUser;
    this.welcomeEmailMessageToSend = welcomeEmailMessageToSend;
    this.isFromGmtUser = isFromGmtUser;
    this.userScopes = userScopes;
    this.password = password;
  }
}
